import {Injectable} from '@angular/core';
import {Group, ReportFilters} from 'app/features/analytics/service/filter-value.interface';
import {FilterValueService} from 'app/features/analytics/service/filter-value.service';
import {Dimension, KnownMeasure} from 'app/features/analytics/features/reports/dimension';
import {DimensionsAndMeasuresService} from 'app/features/analytics/service/dimensions-and-measures.service';
import {AuthService} from 'app/core/services/auth.service';
import {FilterAutoOpenService} from 'app/features/analytics/service/filter-auto-open.service';
import {SessionStorageService} from 'app/core/services/session-storage.service';
import {I18NextPipe} from 'angular-i18next';
import {UserpilotService} from 'app/core/services/userpilot.service';
import {DemoService} from 'app/core/services/demo.service';
import {StatsHelperService} from 'app/features/analytics/service/stats-helper.service';
import {Dimension as GraphQLDimension, TopFilterInput, TopFilterOrder} from '../../../../../../globalTypes';
import {Sentry} from 'app/core/error-handler/sentry.service';

export interface OverviewFilters extends ReportFilters {
    groupBy: Group[];
    newInstalls?: Dimension;
    profitLoss?: Dimension;
    uaSplit?: Dimension;
    uaDay?: number;
    userId?: string;
}

@Injectable()
export class BusinessOverviewFilterValueService extends FilterValueService {
    get initialValue(): OverviewFilters {
        return {
            ...this.getInitialValue(),
            topFilter: {...this.defaultTopFilter()},
            isDemo: this.lastIsDemoValue,
        };
    }

    get value(): OverviewFilters {
        return this.value$.getValue();
    }

    set value(value) {
        this.value$.next(value);
    }

    defaultTopFilter(): TopFilterInput {
        return {
            dimension: GraphQLDimension.APP,
            includeOthers: true,
            limit: 10,
            measure: {
                id: KnownMeasure.TotalRevenue,
            },
            order: TopFilterOrder.TopValues,
        };
    }

    constructor(
        dms: DimensionsAndMeasuresService,
        auth: AuthService,
        autoOpen: FilterAutoOpenService,
        sessionStorage: SessionStorageService,
        i18Next: I18NextPipe,
        userpilotService: UserpilotService,
        demo: DemoService,
        helper: StatsHelperService,
        sentry: Sentry
    ) {
        super(dms, auth, autoOpen, sessionStorage, i18Next, userpilotService, demo, helper, sentry);
        this.afterCreate();
    }
}
